import login from '~/gql/auth/login.gql'
import discordAuth from '~/gql/auth/discordAuth.gql'

export default {
  login,
  discordAuth
}
